import type { Dictionary } from '../i18n.js';

export const server: Dictionary = {
  // index.ts
  'That check was lost. Try again.': 'Wynik sprawdzania przepadł. Spróbuj ponownie.',
  'Place search needs a network connection.': 'Wyszukiwanie miejsc wymaga połączenia z siecią.',
  'Place search failed. Pan the map instead.': 'Wyszukiwanie miejsc nie powiodło się. Przesuń mapę ręcznie.',
  'Sign in to save a tour.': 'Zaloguj się, żeby zapisać turniej.',
  'No such tour.': 'Nie ma takiego turnieju.',
  'Sign in to delete a tour.': 'Zaloguj się, żeby usunąć turniej.',
  'That tour is not yours to delete.': 'To nie twój turniej — nie możesz go usunąć.',
  'Sign in to vote.': 'Zaloguj się, żeby głosować.',
  'World not found — it may have been evicted. Restart the race.':
    'Nie znaleziono świata — mógł już zniknąć z pamięci serwera. Uruchom wyścig od nowa.',
  'You are no longer in this lobby': 'Nie jesteś już w tym lobby',
  'Only the host can pick the region': 'Tylko gospodarz może wybrać obszar',
  'Only the host can set the AI opponents': 'Tylko gospodarz może ustawić przeciwników AI',
  'Only the host can choose between a race and a free drive': 'Tylko gospodarz może wybrać między wyścigiem a swobodną jazdą',
  'Only the host can choose the weather': 'Tylko gospodarz może wybrać pogodę',
  'Only the host can pick the tour': 'Tylko gospodarz może wybrać turniej',
  'That tour no longer exists. Refresh the list.': 'Ten turniej już nie istnieje. Odśwież listę.',
  '"{tour}" cannot be raced: {reason}': 'Turnieju „{tour}” nie da się rozegrać: {reason}',
  'Only the host can start the race': 'Tylko gospodarz może rozpocząć wyścig',
  'Only the host can stop the world building': 'Tylko gospodarz może przerwać budowanie świata',
  'Only the host can end the tour': 'Tylko gospodarz może zakończyć turniej',
  'Only the host can return everyone to the lobby': 'Tylko gospodarz może przenieść wszystkich z powrotem do lobby',
  'No lobby with code {code}. Check the code, or create a new race.':
    'Nie ma lobby z kodem {code}. Sprawdź kod albo utwórz nowy wyścig.',
  'That lobby is full ({max} players).': 'To lobby jest pełne ({max} graczy).',
  'That race has already started. Wait for it to finish, or start a new one.':
    'Ten wyścig już wystartował. Poczekaj, aż się skończy, albo zacznij nowy.',

  // lobby.ts
  'Pick a region first.': 'Najpierw wybierz obszar.',
  'Stopped building the world. Anything Overpass did send has been cached, so trying again is usually much quicker.':
    'Przerwano budowanie świata. To, co Overpass zdążył przysłać, zostało zapamiętane, więc kolejna próba zwykle idzie dużo szybciej.',
  Starting: 'Zaczynamy',
  'World generation failed: {reason}': 'Nie udało się zbudować świata: {reason}',
  Somewhere: 'Gdzieś',

  // worlds.ts
  'That start direction is not a bearing.': 'Ten kierunek startu nie jest poprawnym azymutem.',
  'Pick between 0 and {max} checkpoints.': 'Wybierz od 0 do {max} punktów kontrolnych.',
  'Those checkpoints are not a list.': 'Te punkty kontrolne nie tworzą listy.',
  'A race can hold {max} placed checkpoints.': 'Wyścig może mieć najwyżej {max} postawionych punktów kontrolnych.',
  'One of those checkpoints is not a place.': 'Jeden z punktów kontrolnych nie wskazuje żadnego miejsca.',
  'Unknown region "{region}"': 'Nieznany obszar „{region}”',
  'That region box is not valid.': 'Ten prostokąt obszaru jest nieprawidłowy.',
  'That region is {area} km². The limit is {max} km² — drag a smaller box.':
    'Ten obszar ma {area} km². Limit to {max} km² — zaznacz mniejszy prostokąt.',
  'That region is only {area} km². Pick at least {min} km² so there is somewhere to race.':
    'Ten obszar ma tylko {area} km². Wybierz co najmniej {min} km², żeby było gdzie się ścigać.',
  'Reading the map data': 'Wczytywanie danych mapy',
  'Collecting the map data': 'Zbieranie danych mapy',
  'Downloading the streets from OpenStreetMap': 'Pobieranie ulic z OpenStreetMap',
  'Reading the streets': 'Wczytywanie ulic',
  '{done} of {total} map tiles': '{done} z {total} kafelków mapy',
  'Building roads, buildings and the racing line': 'Budowanie dróg, budynków i toru jazdy',
  'Packing the world for the drivers': 'Pakowanie świata dla kierowców',

  // accounts.ts
  'Names are at least three characters.': 'Nazwa musi mieć co najmniej trzy znaki.',
  'Names are at most {max} characters.': 'Nazwa jest za długa (limit znaków: {max}).',
  'Somebody already races under that name.': 'Ktoś już ściga się pod tą nazwą.',
  'An account holds {max} passkeys. Remove one first.':
    'Konto może mieć najwyżej {max} kluczy dostępu. Najpierw usuń jeden.',
  'That is your only passkey. Add another before removing this one.':
    'To twój jedyny klucz dostępu. Dodaj kolejny, zanim usuniesz ten.',

  // auth.ts
  'Sign-in failed. Try again.': 'Logowanie nie powiodło się. Spróbuj ponownie.',
  'Sign in first.': 'Najpierw się zaloguj.',
  Passkey: 'Klucz dostępu',
  'That sign-up expired. Start again.': 'Rejestracja wygasła. Zacznij od nowa.',
  'That sign-in did not complete.': 'Logowanie nie zostało dokończone.',
  'That passkey is not registered here.': 'Ten klucz dostępu nie jest tu zarejestrowany.',
  'That sign-up did not complete.': 'Rejestracja nie została dokończona.',
  'That passkey could not be verified.': 'Nie udało się zweryfikować tego klucza dostępu.',
  'That passkey is already registered.': 'Ten klucz dostępu jest już zarejestrowany.',
  'That took too long. Start again.': 'Trwało to zbyt długo. Zacznij od nowa.',

  // tourStore.ts
  'Give the tour a name.': 'Nadaj turniejowi nazwę.',
  'That tour no longer exists. Save it as a new one.': 'Ten turniej już nie istnieje. Zapisz go jako nowy.',
  'That tour was made before accounts. It cannot be edited.':
    'Ten turniej powstał, zanim pojawiły się konta. Nie można go edytować.',
  'That tour belongs to somebody else.': 'Ten turniej należy do kogoś innego.',
  'There are already {max} saved tours.': 'Osiągnięto limit zapisanych turniejów ({max}).',
  'You have {max} tours. Delete one before making another.':
    'Masz już maksymalną liczbę turniejów ({max}). Usuń jeden, zanim utworzysz kolejny.',
  'A tour needs at least one race.': 'Turniej musi mieć co najmniej jeden wyścig.',
  'A tour can hold {max} races. Split it into two cups.':
    'Limit wyścigów w turnieju to {max}. Podziel go na dwa puchary.',
  '"{title}" has no region.': '„{title}” nie ma wybranego obszaru.',
  'That {field} is far too long.': 'Pole „{field}” jest o wiele za długie.',
  'A vote is up, down, or neither.': 'Głos jest na tak, na nie albo żaden.',
  name: 'nazwa',
  title: 'tytuł',

  // geocode.ts
  'Place search is unreachable ({reason}).': 'Wyszukiwarka miejsc jest nieosiągalna ({reason}).',
  'Place search returned HTTP {status}.': 'Wyszukiwarka miejsc zwróciła błąd HTTP {status}.',

  // osmSource.ts
  'This region is not cached and the server is running offline. Pick one of the built-in fixture regions instead.':
    'Tego obszaru nie ma w pamięci podręcznej, a serwer działa offline. Wybierz zamiast niego jeden z gotowych obszarów.',
  'OSM_RACER_OVERPASS_URL is set, so only {hosts} was tried — the public servers are deliberately not used as a fallback. Check that your instance is up and reachable, or unset the variable to fall back to the public ones.':
    'Ustawiono OSM_RACER_OVERPASS_URL, więc próbowano tylko {hosts} — publiczne serwery celowo nie służą jako zapasowe. Sprawdź, czy twoja instancja działa i jest osiągalna, albo usuń tę zmienną, żeby wrócić do publicznych.',
  'OSM_RACER_OVERPASS_LOCAL_URL is set and this tile is inside its polygon, so only {hosts} was tried — the public servers are deliberately not used as a fallback. Check that your instance is up and reachable.':
    'Ustawiono OSM_RACER_OVERPASS_LOCAL_URL, a ten kafelek leży w jej poligonie, więc próbowano tylko {hosts} — publiczne serwery celowo nie służą jako zapasowe. Sprawdź, czy twoja instancja działa i jest osiągalna.',
  'The public instances are frequently overloaded — try again in a moment, or race one of the built-in regions, which work offline.':
    'Publiczne serwery są często przeciążone — spróbuj ponownie za chwilę albo ścigaj się na jednym z gotowych obszarów, które działają offline.',
  'Could not reach the Overpass API after {attempts} attempts. {advice}\n{failures}':
    'Nie udało się połączyć z API Overpass po {attempts} próbach. {advice}\n{failures}',

  // weather.ts
  'Clear night': 'Pogodna noc',
  Clear: 'Bezchmurnie',
  'Partly cloudy': 'Częściowe zachmurzenie',
  Overcast: 'Pochmurno',
  Fog: 'Mgła',
  Rain: 'Deszcz',
  Thunderstorm: 'Burza',
  Snow: 'Śnieg',
  '{clock} local': '{clock} czasu lokalnego',
  'forecast unavailable': 'brak prognozy',
  'set by the host': 'ustawione przez gospodarza',
  '{first} · {rest}': '{first} · {rest}',

  // fixtures.ts
  'Kraków — Old Town & the Vistula': 'Kraków — Stare Miasto i Wisła',
  'Rynek Główny, the Planty ring, Wawel and the river bend. 2.3 km².':
    'Rynek Główny, pierścień Plant, Wawel i zakole Wisły. 2,3 km².',
  'The avenue grid between Herald Square and Central Park South. 1.9 km².':
    'Siatka alej między Herald Square a Central Park South. 1,9 km².',
  'Paris — Le Marais': 'Paryż — Le Marais',
  'Tight medieval street grid, the Seine and Île de la Cité. 2.0 km².':
    'Ciasna średniowieczna siatka ulic, Sekwana i Île de la Cité. 2,0 km².',
  'Kraków — Kazimierz (small)': 'Kraków — Kazimierz (mały)',
  'A 0.15 km² slice used by the unit tests. Loads in well under a second.':
    'Wycinek 0,15 km² używany w testach jednostkowych. Wczytuje się w ułamku sekundy.',

  // worldgen.ts
  'Could not find a drivable route between the start and finish points. Try a region with a connected road network, or move the pins closer to a street.':
    'Nie udało się znaleźć przejezdnej trasy między startem a metą. Wybierz obszar ze spójną siecią dróg albo przesuń pinezki bliżej ulicy.',
  'Only the host can move on to the next map': 'Tylko gospodarz może przejść do następnej mapy',
};
